import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { message } from 'antd';
import { authRequest } from '../../helpers/request.helper';
import {
  COMPROBAR_ARTICULOS_REPOSICIONES_STOCK,
  GENERAR_PEDIDO_GW1,
  GET_ARTICULOS_REPOSICIONES,
  GET_ARTICULOS_REPOSICIONES_FAILURE,
  GET_ARTICULOS_REPOSICIONES_REQUEST,
  GET_ARTICULOS_REPOSICIONES_STOCK_FAILURE,
  GET_ARTICULOS_REPOSICIONES_STOCK_REQUEST,
  GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS,
  GET_ARTICULOS_REPOSICIONES_SUCCESS,
  GET_PROVEEDORES_REPOSICIONES_FAILURE,
  GET_PROVEEDORES_REPOSICIONES_SUCCESS,
  GET_PROVEEDORES_REPOSICIONES_REQUEST,
  INICIAR_MODULO_REPOSICIONES_NEWCO,
  INICIAR_MODULO_REPOSICIONES_NEWCO_END,
  SET_PAGINATION_REPOSICION,
  SET_DEFAULT_FILTERS,
  RESETEAR_SELECCION,
  GET_VALORES_PROPIEDADES_ARTICULOS_REQUEST,
  GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS,
  GET_VALORES_PROPIEDADES_ARTICULOS_FAILURE,
  SET_FILTER,
  GET_CSV_ARTICULOS_REPOSICIONES_FAILURE,
  GET_CSV_ARTICULOS_REPOSICIONES_SUCCESS, GET_CSV_ARTICULOS_REPOSICIONES_REQUEST, GENERAR_CSV_ARTICULOS_REPOSICIONES,

} from '../actions/constants/newCo.reposiciones.constants';
import { sendMessageGW1 } from '../../helpers/GW1sendMessage.helper';
import { obtenerParametrosConsultaArticulos } from '../../helpers/modules/reposiciones.helper';

const newCoReposicionesState = state => state.newCoReposiciones;
const core = state => state.core;

function* obtenerArticulosReposiciones({ payload }) {
  yield put({
    type: GET_ARTICULOS_REPOSICIONES_REQUEST,
  });
  const newCoReposiciones = yield select(newCoReposicionesState);
  const { subtiposArticulo } = yield select(core);
  const { tiposArticulo } = yield select(core);
  try {
    const formData = obtenerParametrosConsultaArticulos(newCoReposiciones, subtiposArticulo);
    const requestParams = {
      url: 'api/articulosReposiciones/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, requestParams);
    response.datos.forEach((articulo) => {
      articulo.tipoStr = tiposArticulo.find((tipo) => tipo.id == articulo.tipo).nombre;
    });
    yield put({
      type: GET_ARTICULOS_REPOSICIONES_SUCCESS,
      payload: response,
    });
  } catch (ex) {
    yield put({ type: GET_ARTICULOS_REPOSICIONES_FAILURE, payload: ex });
  }
}
function* obtenerProveedoresReposiciones({ payload }) {
  yield put({
    type: GET_PROVEEDORES_REPOSICIONES_REQUEST,
  });
  try {
    const formData = new FormData();
    formData.append('limite', '500');
    const requestParams = {
      url: 'api/proveedores/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, requestParams);
    yield put({
      type: GET_PROVEEDORES_REPOSICIONES_SUCCESS,
      payload: response,
    });
  } catch (ex) {
    yield put({ type: GET_PROVEEDORES_REPOSICIONES_FAILURE });
  }
}
function* obtenerValoresTipoArticulo({ payload: { tipo, value } }) {
  if (tipo !== 'tipoArticulo') return;
  const { subtiposArticulo } = yield select(core);
  yield put({
    type: GET_VALORES_PROPIEDADES_ARTICULOS_REQUEST,
  });
  try {
    const formData = new FormData();
    formData.append('limite', '-1');
    formData.append('consulta', JSON.stringify({ tipoArticulo: { valor: value } }));
    const requestParams = {
      url: 'api/valoresArticulos/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, requestParams);
    yield put({
      type: GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS,
      payload: { datos: response.datos, tipoArticulo: value, subtiposArticulo },
    });
  } catch (ex) {
    yield put({ type: GET_VALORES_PROPIEDADES_ARTICULOS_FAILURE });
  }
}
function* generarCsvArticulos({ payload }) {
  const newCoReposiciones = yield select(newCoReposicionesState);
  const { subtiposArticulo } = yield select(core);
  yield put({
    type: GET_CSV_ARTICULOS_REPOSICIONES_REQUEST,
  });
  try {
    const formData = obtenerParametrosConsultaArticulos(newCoReposiciones, subtiposArticulo);
    formData.append('seleccion', JSON.stringify(newCoReposiciones.selection));
    const requestParams = {
      url: 'api/reposiciones/csv/generar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, requestParams);
    const blob = new Blob([response], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, 'articulos_reposiciones.csv');
    yield put({ type: GET_CSV_ARTICULOS_REPOSICIONES_SUCCESS });
  } catch (ex) {
    yield put({ type: GET_CSV_ARTICULOS_REPOSICIONES_FAILURE, ex });
  }
}
function* comprobarArticulosReposicionesStock({ payload }) {
  yield put({
    type: GET_ARTICULOS_REPOSICIONES_STOCK_REQUEST,
  });
  const newCoReposiciones = yield select(newCoReposicionesState);
  const { selection: { rowSelection } } = newCoReposiciones;
  try {
    /*
    let url = 'http://intranet2.multiopticas.com/public/etc/swap/ws.products.availability.php?items=';
    rowSelection.forEach((e, i) => {
      url += `E.${e.codigoEdi}`;
      if (i < rowSelection.length - 1) url += '_';
    });
    const requestParams = {
      url,
      method: 'GET',
    };
    const response = yield call(request, requestParams);
     */
    const url = 'api/reposiciones/stock/buscar';
    const formData = new FormData();
    formData.append('articulos', JSON.stringify(rowSelection));
    const requestParams = {
      url,
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, requestParams);
    const articulosStock = [];
    const resultados = response.split('<br>');
    resultados.forEach((resultado) => {
      const cells = resultado.split(';');
      const articuloStock = {};
      cells.forEach((cell) => {
        const [campo, valor] = cell.split('=');
        switch (campo) {
          case 'ItemNo':
            articuloStock.cdgedi = valor;
            break;
          case 'Stock':
            articuloStock.stock = parseInt(valor, 10);
            break;
        }
      });
      if (articuloStock.cdgedi) articulosStock.push(articuloStock);
    });
    yield put({
      type: GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS,
      payload: articulosStock,
    });
    message.success('Acción finalizada correctamente');
  } catch (ex) {
    yield put({ type: GET_ARTICULOS_REPOSICIONES_STOCK_FAILURE });
    message.error('Ocurrió un error al comprobar el stock');
  }
}
function* generarPedidoGw1({ payload }) {
  const newCoReposiciones = yield select(newCoReposicionesState);
  const { selection, articulosReposicionesDataModificados, filters } = newCoReposiciones;
  message.loading('Generando pedido..', 2);
  sendMessageGW1({ action: GENERAR_PEDIDO_GW1, payload: { selection, articulosReposicionesDataModificados, filters } });
}
function* resetearSeleccion({ payload }) {
  yield put({ type: RESETEAR_SELECCION });
}
function* iniciarModuloReposiciones({ payload }) {
  const { subtiposArticulo } = yield select(core);
  yield obtenerProveedoresReposiciones({ payload });
  yield put({
    type: SET_DEFAULT_FILTERS,
    payload: { ...payload, subtiposArticulo },
  });
  yield* obtenerValoresTipoArticulo({ payload: { tipo: 'tipoArticulo', value: payload.tipoArticulo } });
  yield put({
    type: INICIAR_MODULO_REPOSICIONES_NEWCO_END,
  });
}
function* newCoReposicionesSaga() {
  yield all([
    takeLatest(INICIAR_MODULO_REPOSICIONES_NEWCO, iniciarModuloReposiciones),
    takeLatest([GET_ARTICULOS_REPOSICIONES, SET_PAGINATION_REPOSICION], obtenerArticulosReposiciones),
    takeLatest([GET_ARTICULOS_REPOSICIONES], resetearSeleccion),
    takeLatest(COMPROBAR_ARTICULOS_REPOSICIONES_STOCK, comprobarArticulosReposicionesStock),
    takeLatest(SET_FILTER, obtenerValoresTipoArticulo),
    takeLatest(GENERAR_PEDIDO_GW1, generarPedidoGw1),
    takeLatest(GENERAR_CSV_ARTICULOS_REPOSICIONES, generarCsvArticulos),
  ]);
}

export default newCoReposicionesSaga;
